import { render, staticRenderFns } from "./WidgetLogin.vue?vue&type=template&id=3c9d63a8&"
import script from "./WidgetLogin.vue?vue&type=script&lang=js&"
export * from "./WidgetLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c9d63a8')) {
      api.createRecord('3c9d63a8', component.options)
    } else {
      api.reload('3c9d63a8', component.options)
    }
    module.hot.accept("./WidgetLogin.vue?vue&type=template&id=3c9d63a8&", function () {
      api.rerender('3c9d63a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/WidgetLogin.vue"
export default component.exports